import { render, staticRenderFns } from "./TransformTool.vue?vue&type=template&id=08a1f708&scoped=true&"
import script from "./TransformTool.vue?vue&type=script&lang=js&"
export * from "./TransformTool.vue?vue&type=script&lang=js&"
import style0 from "./TransformTool.vue?vue&type=style&index=0&id=08a1f708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1f708",
  null
  
)

export default component.exports